var _path, _g, _path2, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFloors = function SvgFloors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "floors_svg__a",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#floors_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "m28.14 20.134 7.157 3.49L18 32.064.703 23.624l7.046-3.437"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    fillRule: "evenodd",
    d: "m18 15.188 5.766-2.813L18 9.562l-5.766 2.813z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    fillRule: "evenodd",
    d: "M18 20.813 6.469 15.186.703 18l5.766 2.812L18 26.437l11.531-5.625L35.297 18l-5.766-2.813z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "floors_svg__b",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#floors_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.5,
    d: "M.703 12.375 18 3.937l17.297 8.438L18 20.813z"
  }))));
};
export default SvgFloors;